import styled from '@emotion/native';
import React from 'react';
import { Modal as RNModal, ViewStyle } from 'react-native';
import { alphaBlack50 } from '../styles/colors';
import useBreakpoint from '../hooks/useBreakpoint';

const Modal = ({
  isVisible,
  setIsVisible,
  children,
  onDismiss = () => setIsVisible(false),
  onRequestClose = () => setIsVisible(false),
  mobileBackgroundColor = alphaBlack50,
  isTransparent = false,
  style = {},
}: {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  children: React.ReactNode;
  onDismiss?: () => void;
  onRequestClose?: () => void;
  mobileBackgroundColor?: string;
  isTransparent?: boolean;
  style?: ViewStyle;
}) => {
  const { isDesktop } = useBreakpoint();

  return (
    <RNModal
      visible={isVisible}
      animationType={isDesktop ? 'fade' : 'slide'}
      presentationStyle={isTransparent ? 'overFullScreen' : 'fullScreen'}
      onRequestClose={onRequestClose}
      transparent={isDesktop || isTransparent}
      onDismiss={onDismiss}
    >
      <OverlayContainer
        isDesktop={isDesktop}
        mobileBackgroundColor={mobileBackgroundColor}
        style={style}
      >
        {children}
      </OverlayContainer>
    </RNModal>
  );
};

const OverlayContainer = styled.View<{
  isDesktop: boolean;
  mobileBackgroundColor: string;
}>(({ isDesktop, mobileBackgroundColor }) => ({
  flex: 1,
  backgroundColor: isDesktop ? alphaBlack50 : mobileBackgroundColor,
  justifyContent: 'center',
  alignItems: 'center',
  paddingVertical: isDesktop ? 78 : 0,
}));

export default Modal;
